import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

import { Container } from '../../Container'

import './certification.css'

export const Certification = ({ certificateLogos }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: false });

    if(certificateLogos !== null) {
        return (
            <div ref={ref} className='certification'>
                <Container>
                    {certificateLogos.titleVisibility && <motion.h3 className='mt-0 mb-0 h3-compostPlus text-center' style={{
                            transform: isInView ? "none" : "translateX(-200px)",
                            opacity: isInView ? 1 : 0,
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                        }}>{certificateLogos.mediaSliderName}</motion.h3>}
                    <div className='flex wrap justify-center align-center'>
                        {certificateLogos.images.map((item, index) => (
                            <div key={index} className='logo' style={{
                                opacity: isInView ? 1 : 0,
                                transition: `all ${isInView ? 0.9 * index : 0}s cubic-bezier(0.17, 0.55, 0.55, 1) ${isInView ? 0.9 * index : 0}s`
                            }}>
                                <img src={item.gatsbyImageData.images.fallback.src} alt='Logos' />
                            </div>
                        ))}
                    </div>
                </Container>
            </div>
        )
    }
}